import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiUrlFixInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.url.startsWith('/api')) {
            const apiReq = req.clone({ url: `${environment.apiUrl}${req.url}` });
            return next.handle(apiReq);
        }
        else if (req.url.startsWith('api')) {
            const apiReq = req.clone({ url: `${environment.apiUrl}/${req.url}` });
            return next.handle(apiReq);
        }

        return next.handle(req);
    }

}
